import { inputStyle } from "./FormField";

export type StatusFilterValue = "all" | "active" | "inactive";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): el selector "Estado · todos
// / Activo / Inactivo" de la barra de filtros era el mismo marcado palabra
// por palabra en BenefitsScreen.tsx y RewardsScreen.tsx. Extracción sin
// cambio de comportamiento ni de valores visuales.
export function StatusFilterSelect({
  value,
  onChange,
}: {
  value: StatusFilterValue;
  onChange: (value: StatusFilterValue) => void;
}) {
  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value as StatusFilterValue)}
      style={{
        ...inputStyle,
        width: "auto",
        minWidth: 140,
        cursor: "pointer",
      }}
    >
      <option value="all">Estado · todos</option>
      <option value="active">Activo</option>
      <option value="inactive">Inactivo</option>
    </select>
  );
}
